export default __webpack_public_path__ + "static/media/mathsIcon.b2842c90.svg";